import React, { useEffect, useState } from 'react';
import CheckBoxSelection from './CheckBoxSelection';
import RadioButtonSelection from './RadioButtonSelection';
import styles from './common.module.scss';
import { messageToChoose, IItemsModifierSet, IItemsModifier } from './common';
import RequiredModifier from './RequiredModifiers';
import { useIntl } from 'react-intl';

export interface IModifierProps {
	modifierSet: IItemsModifierSet;
	selectedModifierSets: string[];
	handleModifiers(updateSelectedModifierSets: string[], selectedKey?: string, controlSelection?: string): void;
	isChildDisabled: boolean;
	modifierCurrentIndex: number;
	modifierLastIndex: string;
	requiredModifierErr?: boolean | undefined;
	requiredModifierRef?: string | undefined;
	setRequiredModifierErr?: React.Dispatch<React.SetStateAction<boolean>> | undefined;
}

const Modifier: React.FC<IModifierProps> = ({
	modifierSet,
	selectedModifierSets,
	handleModifiers,
	isChildDisabled,
	modifierCurrentIndex,
	modifierLastIndex,
	requiredModifierErr,
	requiredModifierRef,
	setRequiredModifierErr,
}) => {
	const intl = useIntl();
	const MINIFIED_HEADER_DEFAULT_HEIGHT = 122;
	const NAV_BAR_DEFAULT_HEIGHT = 47;
	const Z_INDEX_MAX_VALUE = 20;
	const modifierSetDetails = modifierSet?.modifierSetDetails;
	const modifiers = modifierSet?.modifiers;
	const [miniHeaderHeight, setMiniHeaderHeight] = useState<number>(122);
	const qtyModifierAvailable: number =
		(modifiers?.length &&
			modifiers.filter((modifierData: IItemsModifier) => {
				return modifierData?.modifierDetails?.available;
			}).length) ||
		0;
	const navBarHeight = document.getElementById('navigationSection')?.offsetHeight || NAV_BAR_DEFAULT_HEIGHT;
	const minifiedheader = document.getElementById('miniHeader')?.offsetHeight || MINIFIED_HEADER_DEFAULT_HEIGHT;
	const errBoxHeight = document.getElementById('errorMsgBox')?.offsetHeight || 40;
	const modifierTopheight = miniHeaderHeight + navBarHeight + (requiredModifierErr ? errBoxHeight : 0);
	const modiferLevel = modifierLastIndex.split('-').length;
	const isError = requiredModifierRef === modifierSetDetails?.ref && requiredModifierErr;

	const getModifierMessage = () => {
		return messageToChoose(
			intl,
			modifierSetDetails?.minModifiersPerSet || 0,
			modifierSetDetails?.maxModifiersPerSet || 0,
			qtyModifierAvailable
		);
	};

	useEffect(() => {
		const modifierParentHeight = document.getElementById(`modiferLevel-${modifierLastIndex}`)?.offsetHeight;
		if (modifierParentHeight) {
			setMiniHeaderHeight(minifiedheader + modifierParentHeight);
		} else {
			setMiniHeaderHeight(minifiedheader);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [minifiedheader]);

	const shouldUseCheckbox = () => {
		const max = modifierSetDetails?.maxModifiersPerSet;
		const min = modifierSetDetails?.minModifiersPerSet;

		return max && ((max > 1 || !min) && max !== 1);
	}

	return (
		<div id={modifierSet.key} className={styles.modifierMainBlock}>
			<div
				className={styles.modifierHeader}
				id={`modiferLevel-${modifierLastIndex}-${modifierCurrentIndex}`}
				style={{ top: modifierTopheight, zIndex: Z_INDEX_MAX_VALUE - modiferLevel }}
			>
				<div className={styles.modifierHeaderLeftBlock}>
				<div className={`${styles.modifierName} ${isError ? styles.errorText : ''}`}>
				{modifierSetDetails?.name}
					</div>
					<div className={styles.modifierHeaderRightBlock}>
						{modifierSet.hasModifiers && (
							<div className={`${styles.modifierChoice} ${isError ? styles.errorText : ''}`}>
								{getModifierMessage()}
							</div>
						)}
					</div>
				</div>
				{modifierSet.hasModifiers && (
					<RequiredModifier
						minimumModifiers={modifierSetDetails?.minModifiersPerSet || 0}
						maximumModifier={modifierSetDetails?.maxModifiersPerSet || 0}
						totalModifierAvailable={qtyModifierAvailable}
						modifiersArray={modifierSet.modifiers}
						selectedModifierSets={selectedModifierSets}
						modifierSet={modifierSet}
						requiredModifierErr={requiredModifierErr}
						requiredModifierRef={requiredModifierRef}
						setRequiredModifierErr={setRequiredModifierErr}
					/>
				)}
			</div>
			{!modifierSet.hasModifiers && (
				<div className={styles.modifierBody} id="modifierMsgContainer">
					<div className={`${styles.modifierHeader} ${styles.modifierUnavailable}`}>
						{intl.formatMessage({ id: 'component:modifier:unavailable:text' })}
					</div>
				</div>
			)}
			<div className={styles.modifierBody}>
				{modifierSetDetails?.maxModifiersPerSet && shouldUseCheckbox() ? (	
					<CheckBoxSelection
						modifiers={modifiers || []}
						selectedModifierSets={selectedModifierSets}
						maxModifiersPerSet={modifierSetDetails?.maxModifiersPerSet}
						handleModifiers={handleModifiers}
						parentKey={modifierSet.key}
						isChildDisabled={isChildDisabled}
						modifierSetIndex={`${modifierLastIndex}-${modifierCurrentIndex}`}
					/>
				) : (
					<RadioButtonSelection
						modifiers={modifiers || []}
						selectedModifierSets={selectedModifierSets}
						handleModifiers={handleModifiers}
						isChildDisabled={isChildDisabled}
						parentKey={modifierSet.key}
						modifierSetIndex={`${modifierLastIndex}-${modifierCurrentIndex}`}
					/>
				)}
			</div>
		</div>
	);
};

export default Modifier;
